export const search = {
  Songs: 'Canzoni',
  Playlists: 'Playlist',
  'Top Result': 'Miglior risultato',
  'No results': 'Nessun risultato',
  'No results where found for': 'Nessun risultato trovato per',
};
